import { useEffect, useState } from "react";
import {
  getStoredClientUser,
  logoutClient,
  subscribeToClientAuth,
} from "../store/api/clientAuthApi";

export const useClientAuth = () => {
  const [clientUser, setClientUser] = useState(() => getStoredClientUser());

  useEffect(() => {
    const syncClientUser = () => {
      setClientUser(getStoredClientUser());
    };

    return subscribeToClientAuth(syncClientUser);
  }, []);

  return {
    clientUser,
    logout: logoutClient,
  };
};
